export default {
    LOAD_LOCAL(state, local) {
        state.items = local
    }
}